import { combineReducers } from 'redux';
import mcGlobalUnreadNum from './mc-global-unread-num';
import mcGroupUnreadNum from './mc-group-unread-num';
import mcTypeUnreadNum from './mc-type-unread-num';
import mcNewPopupMsg from './mc-new-popup-msg';
import mcOptJoinTime from './mc-opt-join-time';

export default combineReducers({
  mcGlobalUnreadNum,
  mcGroupUnreadNum,
  mcTypeUnreadNum,
  mcNewPopupMsg,
  mcOptJoinTime,
});
